import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';



const SELECTOR = '.organism-sticky-page-up';



class OrganismStickyPageUp {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$button = this._$element.find('.page-up-button').first();

			this._$footerNav = $('.organism-footer').first();

			this._originalBottomOffset = parseInt(this._$element.css('bottom'), 10) || 0;

			this._prime();
		}
	}



	_prime(){
		this._$element.css('bottom', this._originalBottomOffset);

		this._$button.on('click', (e) => {
			e.preventDefault();

			$('body').scrollTo(
				() => { this._$button.blur(); },
				750,
				Math.round(this._app.getViewportInfo().viewportHeight / 2),
				true,
				true
			);
		});

		if(
			!Context.get('runningInPatternLabList')
			&& !Context.get('runningInPatternLabDetails')
		){
			this._app.registerFuzzyUpdateLoopCallback('sticky-page-up-management', (viewportInfo) => {
				if(
					(viewportInfo.scrollDirection === 'down')
					&& (viewportInfo.scrollTop >= viewportInfo.viewportHeight)
				){
					if (!this._$element.hasClass('active')) {
						this._$element.addClass('active');
					}
					if (this._$element.hasClass('scroll-up')) {
						this._$element.removeClass('scroll-up');
					}
					if ((viewportInfo.scrollTop + viewportInfo.viewportHeight) > this._$footerNav.offset().top) {
						if (!this._$element.hasClass('not-sticky')) {
							this._$element.addClass('not-sticky');
						}
					} else if (this._$element.hasClass('not-sticky')) {
						this._$element.removeClass('not-sticky');
					}
				} else if (viewportInfo.scrollDirection === 'up') {
					if (!this._$element.hasClass('scroll-up')) {
						this._$element.addClass('scroll-up');
					}
					if( (viewportInfo.scrollTop < viewportInfo.viewportHeight)) {
						if (this._$element.hasClass('active')) {
							this._$element.removeClass('active');
						}
					}
					if ((viewportInfo.scrollTop + viewportInfo.viewportHeight) < this._$footerNav.offset().top) {
						if (this._$element.hasClass('not-sticky')) {
							this._$element.removeClass('not-sticky');
						}
					}
				}
			});

			//###( EVENTS )###

			this._$element.on('hide-on-page.app', () => {
				this._$element.addClass('hidden');
			});

			this._$element.on('show-on-page.app', () => {
				this._$element.removeClass('hidden');
			});
		}
	}

}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);
		new OrganismStickyPageUp(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}
